const state = {
  drag: {
    element: null,
    elementValue: null,
    elementsViewMap: {},
    startIndex: null
  },
  drop: {
    targets: [],
    target: null
  },
  touch: {
    dropTarget: null
  }
}

export default state
